import { DateTime, DurationLike } from 'luxon';
import {
  MonthWeekDayRecurrenceType,
  WeekDay
} from 'src/app/core/services/extended-program-guide.service';
import getDateTimeWeekDay from './getDateTimeWeekDay';

export default function findMonthlyRecurrenceWeekDay(
  day: DateTime,
  weekday: WeekDay,
  recurrence: MonthWeekDayRecurrenceType
): DateTime {
  const desiredWeekDay = getDateTimeWeekDay(weekday);
  const dayTime: DurationLike = {
    hour: day.hour,
    minute: day.minute,
    second: day.second,
    millisecond: day.millisecond
  };
  if (recurrence === MonthWeekDayRecurrenceType.Last) {
    day = day.endOf('month').set(dayTime);
    while (day.weekday !== desiredWeekDay) {
      day = day.minus({ days: 1 });
    }
  } else {
    day = day.startOf('month').set(dayTime);
    let weekSkipCount: number;
    switch (recurrence) {
      case MonthWeekDayRecurrenceType.First:
        weekSkipCount = 0;
        break;
      case MonthWeekDayRecurrenceType.Second:
        weekSkipCount = 1;
        break;
      case MonthWeekDayRecurrenceType.Third:
        weekSkipCount = 2;
        break;
      case MonthWeekDayRecurrenceType.Fourth:
        weekSkipCount = 3;
        break;
    }
    /**
     * Skip the current date until the desired weekday is reached.
     */
    while (day.weekday !== desiredWeekDay) {
      day = day.plus({ days: 1 });
    }
    /**
     * Skip the amount of weeks until the desired order of the weekday is reached.
     * first weekday = 0 week
     * second weekday = 1 week
     * third weekday = 2 weeks
     * fourth weekday = 3 weeks
     */
    while (weekSkipCount > 0) {
      day = day.plus({ week: 1 });
      weekSkipCount--;
    }
  }

  return day;
}
